<template>
    <div id="document-category-card-component" v-if="total > 0" class="mb-6">
        <p class="font-20 font-weight-medium mb-2">{{ $t('document_by_pro_component.your_categories') }}</p>

        <div class="grid">
            <v-row>
                <v-col v-for="category in categories" :key="category.id" cols="12" lg="4" md="6" xl="3">
                    <v-card
                        :class="{ 'document-category-card--selected': selected.includes(category.id) }"
                        class="document-category-card d-flex align-center gap-3 pa-3"
                        elevation="0"
                        @click="$emit('toggle', category)"
                    >
                        <v-icon>mdi-folder</v-icon>

                        <div class="min-w-0 flex-1-1">
                            <span class="d-block font-weight-bold text-overflow-ellipsis">{{ category.category_name }}</span>
                            <span class="d-block font-12 font-color-medium">
                                {{ $tc('document_by_pro_component.document_count', category.document_count) }}
                            </span>
                        </div>

                        <v-icon>mdi-chevron-right</v-icon>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-pagination v-if="pageCount > 1" v-model="current_page" :length="pageCount" class="mt-2" total-visible="3" />
    </div>
</template>

<script>
export default {
    name: 'DocumentCategoryCardComponent',
    components: {},
    props: {
        categories: {
            type: Array,
            required: true,
        },
        selected: {
            type: Array,
            required: false,
            default: function () {
                return []
            },
        },
        total: {
            type: Number,
            required: false,
            default: 0,
        },
        perPage: {
            type: Number,
            required: false,
            default: 12,
        },
        page: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    computed: {
        current_page: {
            get() {
                return this.page
            },
            set(value) {
                this.$emit('update:page', value)
            },
        },

        pageCount() {
            return Math.ceil(this.total / this.perPage)
        },
    },
}
</script>

<style scoped>
.document-category-card {
    border: 2px solid transparent;
    cursor: pointer;
}

.document-category-card--selected {
    border-color: var(--v-primary-base);
    background-color: var(--v-primary-lighten5);
}
</style>
